import React from 'react';

const JSLogo = (props) => (
    <svg preserveAspectRatio="xMidYMid" viewBox="0 0 256 256" {...props}>
        <path fill="#F7DF1E" d="M0 0h256v256H0V0z" />
        <path d="M67.3 214L87 202c3.8 6.8 7.2 12.4 15.5 12.4 7.9 0 12.9-3 12.9-15v-81.9h24v82.2c0 24.9-14.6 36.2-35.9 36.2-19.2 0-30.4-10-36-22m84.9-2.5L172 200c5.1 8.4 11.8 14.6 23.7 14.6 10 0 16.3-5 16.3-11.8 0-8.3-6.5-11.2-17.5-16l-6-2.6c-17.4-7.4-28.9-16.7-28.9-36.3 0-18 13.7-31.7 35.2-31.7 15.3 0 26.3 5.3 34.2 19.2l-18.7 12c-4.1-7.4-8.6-10.3-15.5-10.3-7 0-11.5 4.5-11.5 10.3 0 7.2 4.5 10.2 14.8 14.6l6 2.6c20.5 8.8 32 17.7 32 37.8 0 21.7-17 33.5-39.9 33.5-22.3 0-36.8-10.6-43.8-24.5" />
    </svg>
);

export default JSLogo;
